/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { TownshipListResponseDto } from '../../models/township-list-response-dto';

export interface GetTownshipList$Params {}

export function getTownshipList(
  http: HttpClient,
  rootUrl: string,
  params?: GetTownshipList$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<TownshipListResponseDto>> {
  const rb = new RequestBuilder(rootUrl, getTownshipList.PATH, 'get');
  if (params) {
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TownshipListResponseDto>;
      }),
    );
}

getTownshipList.PATH = '/township';
